import { render, staticRenderFns } from "./ScreenTabStatusFooterSkeletonLoader.vue?vue&type=template&id=4fe1cc7e&scoped=true&"
import script from "./ScreenTabStatusFooterSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./ScreenTabStatusFooterSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTabStatusFooterSkeletonLoader.vue?vue&type=style&index=0&id=4fe1cc7e&lang=scss&scoped=true&"
import style1 from "./ScreenTabStatusFooterSkeletonLoader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe1cc7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
